import { saveOverlay, STEP_STATUSES, stepStatusLabel } from "../../js/api/filePacket";
import { useAuth } from "../../js/hooks/useAuth";

export default function FileLifecycle({ file, onChange }) {
  const { session } = useAuth();

  function updateStage(stageId, patch) {
    saveOverlay(
      file.id,
      {
        lifecycle: {
          [stageId]: {
            status: patch.status ?? file.overlay.lifecycle?.[stageId]?.status ?? "not_started",
            notes: patch.notes ?? file.overlay.lifecycle?.[stageId]?.notes ?? "",
            updatedAt: new Date().toISOString(),
          },
        },
      },
      session,
      "file.lifecycle",
      { stage: stageId }
    );
    onChange?.();
  }

  return (
    <section className="card stack file-section">
      <div>
        <h2>File lifecycle</h2>
        <p className="muted">
          Contact through close or dissolution. Each stage keeps its own status and notes, and
          prints in the File Packet.
        </p>
      </div>
      <ol className="file-lifecycle">
        {(file.lifecycle || []).map((stage, index) => (
          <li key={stage.id} className={`file-lifecycle__item is-${stage.status}`}>
            <header>
              <span className="file-lifecycle__index">{index + 1}</span>
              <div>
                <h3>{stage.title}</h3>
                <p className="muted">{stage.detail}</p>
              </div>
              <span className="badge">{stepStatusLabel(stage.status)}</span>
            </header>
            <div className="file-stage-fields">
              <label className="field">
                <span className="field-label">Status</span>
                <select
                  className="field-select"
                  value={stage.status}
                  onChange={(event) => updateStage(stage.id, { status: event.target.value })}
                >
                  {STEP_STATUSES.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </label>
              <label className="field">
                <span className="field-label">Notes</span>
                <textarea
                  className="field-textarea"
                  rows={3}
                  value={stage.notes}
                  onChange={(event) => updateStage(stage.id, { notes: event.target.value })}
                  placeholder="First conversation, how they arrived, anything the office should remember."
                />
              </label>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
